/**
 * Update legacy domain scores in a table
 * @param {string} tableId - ID of the table to update
 * @param {Object} scoresByPrefix - Scores organized by prefix
 */
function updateLegacyDomainScoresInTable(tableId, scoresByPrefix) {
	const prefixKeys = scoresByPrefix ? Object.keys(scoresByPrefix) : [];
	console.log(`[updateLegacyDomainScoresInTable] Called tableId=${tableId}, prefixCount=${prefixKeys.length}, prefixes=`, prefixKeys.slice(0, 20));
	const table = document.getElementById(tableId);
	if (!table) {
		console.error(`[updateLegacyDomainScoresInTable] Table with ID '${tableId}' not found.`);
		return;
	}

	const tbody = table.getElementsByTagName('tbody')[0];
	if (!tbody) {
		console.error(`[updateLegacyDomainScoresInTable] tbody not found in table '${tableId}'.`);
		return;
	}

	// Reset all scores in the table to 0.00 first to clear old values
	for (let i = 0; i < tbody.rows.length; i++) {
		const row = tbody.rows[i];
		if (row.cells.length > 1) {
			row.cells[1].textContent = '0.00';
		}
	}

	// Mapping from CCC prefixes to legacy table row text (based on original PrefixToDomainTitles function)
	const prefixToRowText = {
		// Governance/Scope mappings (legacy mode)
		'GOV': 'Governance',
		'THR': 'Threat Management',
		'POL': 'Security Policy Management',
		'EDU': 'Education and Awareness',
		'PM': 'Project Management',
		'CHM': 'Exception Management',
		'MET': 'Metrics Management',
		'AUD': 'Audit Management',
		'TPM': 'Third Party Management',
		'RR': 'Risk Reporting',
		'PER': 'Personnel Management',
		'PHY': 'Physical Security',
		'BCP': 'Business Continuity',
		'IM': 'Incident Management',
		'PRV': 'Data Privacy',
		
		// Technical mappings (legacy mode)
		'AID': 'Asset Inventory',
		'SID': 'Software Inventory',
		'AC': 'Application Control',
		'PAT': 'Patch Management',
		'VM': 'Vulnerability Management',
		'CM': 'Configuration Management',
		'END': 'Endpoint Protection',
		'REM': 'Removable Media Protection',
		'BAC': 'Backup and Recovery',
		'LOG': 'Log Management',
		'FIM': 'File Integrity Management',
		'IDM': 'Identity Management',
		'ID': 'Identity Management',
		'DI': 'Data Inventory Management',
		'AM': 'Access Management',
		'PAM': 'Privileged Account Management',
		'NDM': 'Network Device Management',
		'MDM': 'Mobile Device Protection',
		'BD': 'Boundary Filtering',
		'RA': 'Remote Access',
		'WF': 'Web Filtering',
		'EF': 'Email Filtering',
		'NSC': 'Network Segmentation',
		'WIR': 'Wireless',
		'SDS': 'Software Development',
		'SCA': 'Static Code Analysis',
		
		// Additional mappings from original function
		'PRG': 'Program Management',
		'SAF': 'Safeguard Selection Management',
		'AST': 'Asset Management',
		'IMP': 'Safeguard Implementation Management',
		'VAL': 'Safeguard Validation Management',
		'TPR': 'Third-Party Risk Management',
		'COM': 'Risk Communication Management',
		'RES': 'Resilience Management',
		'AI': 'Artificial Intelligence Management',
		'SYS': 'System Protection Management',
		'SW': 'Software Management',
		'CFG': 'Configuration Management',
		'VUL': 'Vulnerability Management',
		'PNA': 'Perimeter Network Access Management',
		'INA': 'Internal Network Access Management',
		'CSP': 'Cloud Service Provider Management',
		'EM': 'Email Management',
		'SDM': 'Software Development Standardization Management',
		'SDV': 'Software Development Vulnerability Management',
		'DTA': 'Data Inventory Management'
	};

	// Update scores for each prefix
	let updatedRows = 0;
	Object.keys(scoresByPrefix).forEach(prefix => {
		const scoreData = scoresByPrefix[prefix];
		if (scoreData && typeof scoreData.averageScore === 'number' && !isNaN(scoreData.averageScore)) {
			const rowText = prefixToRowText[prefix];
			if (rowText) {
				let found = false;
				for (let i = 0; i < tbody.rows.length; i++) {
					const row = tbody.rows[i];
					const firstCell = row.cells[0];
					if (firstCell && firstCell.textContent.includes(rowText)) {
						if (row.cells.length > 1) {
							row.cells[1].textContent = scoreData.averageScore.toFixed(2);
							updatedRows++;
							found = true;
						}
						break;
					}
				}
				if (!found) console.log(`[updateLegacyDomainScoresInTable] No row found for prefix ${prefix} (rowText="${rowText}")`);
			} else {
				console.log(`[updateLegacyDomainScoresInTable] No prefixToRowText mapping for prefix: ${prefix}`);
			}
		}
	});
	console.log(`[updateLegacyDomainScoresInTable] ${tableId} done: updated ${updatedRows} rows, tbody.rows.length=${tbody.rows.length}`);
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
	module.exports = updateLegacyDomainScoresInTable;
} else if (typeof window !== 'undefined') {
	window.updateLegacyDomainScoresInTable = updateLegacyDomainScoresInTable;
}
